import {AccessorsMutatorsDecorator} from "../../helpers";
import {TranslatableModel} from "./translatable-model";


export class MabeetProfile extends TranslatableModel {}

AccessorsMutatorsDecorator(
    'property_id',
    'name',
    'name_ar',
    'address_line_1',
    'address_line_1_ar',
    'address_line_2',
    'address_line_2_ar',
    'office',
    'vat_number',
    'vat_percentage'
)(MabeetProfile);


// WEBPACK FOOTER //
// ./src/pms-api/models/mabeet-profile.model.js